import { apiFetch } from "./client";

export type ActivateAgentPaidAccessPayload = {
  readonly reason: string;
  readonly entitlement_path_ready: true;
};

export type ActivateAgentPaidAccessResult = {
  readonly agent_id: string;
  readonly monetization_status: "paid_active";
  readonly monetization_plan_id: string;
};

export async function activateAgentPaidAccess(
  agentId: string,
  payload: ActivateAgentPaidAccessPayload,
): Promise<ActivateAgentPaidAccessResult> {
  const res = await apiFetch<{ data: ActivateAgentPaidAccessResult }>(
    `/admin/billing/agent-commerce/agents/${agentId}/paid-access/activate`,
    {
      method: "POST",
      body: JSON.stringify({
        reason: payload.reason,
        entitlement_path_ready: payload.entitlement_path_ready,
      }),
    },
  );
  return res.data;
}
